"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTRA_GROUP_IDS = exports.ENTRA_GROUPS = void 0;
exports.ENTRA_GROUPS = {
    TIER1: 'SG-AIHub-Tier1',
    TIER2: 'SG-AIHub-Tier2',
    TIER3: 'SG-AIHub-Tier3',
    DEEP_THINKING: 'SG-AIHub-DeepThinking',
    ADMINS: 'SG-AIHub-Admins',
};
// These will be populated with actual Entra group Object IDs after provisioning
exports.ENTRA_GROUP_IDS = {
    [exports.ENTRA_GROUPS.TIER1]: '',
    [exports.ENTRA_GROUPS.TIER2]: '',
    [exports.ENTRA_GROUPS.TIER3]: '',
    [exports.ENTRA_GROUPS.DEEP_THINKING]: '',
    [exports.ENTRA_GROUPS.ADMINS]: '',
};
//# sourceMappingURL=entra-groups.js.map